module.exports = __webpack_public_path__ + "img/pc_banner_rule.0885a86b.jpeg";